import { render, staticRenderFns } from "./ViewPurchaseInvoice.vue?vue&type=template&id=6338ee80"
import script from "./ViewPurchaseInvoice.vue?vue&type=script&lang=ts"
export * from "./ViewPurchaseInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports